import styled from "styled-components";
import { BADI_COLORS, unitizedPx } from "@badi/badi-components";
import { getCDNUrl } from "base/shared/Utils";

export const CloseIconWrapper = styled.button`
  width: auto;
  padding: 0;
  background: transparent;
  border: 0;
  position: absolute;
  right: ${unitizedPx(2)};
  top: ${unitizedPx(2)};
`;

export const Root = styled.div`
  background-color: ${BADI_COLORS.BRAND.TERTIARY.HOVER};
  background-image: url(${getCDNUrl()}/assets/images/banner-download-bg.png);
  background-repeat: no-repeat;
  background-size: cover;

  padding: ${unitizedPx(2)};
`;
